import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";
import Flag from "../assets/images/flag.png";
import { toast } from "react-toastify";
import { ownerLogin } from "../redux/actions/authAction";
import Logo from "../assets/images/bayin.png";
import { useTranslation } from "react-i18next";
import i18n from "../i18n/config";
import { io } from "socket.io-client";

const initialState = {
    email: "",
    password: "",
    errors: {},
    loading: false,
}

const Login = () => {


    const {i18n ,t} = useTranslation();
    // const {i18n ,t} = useTranslation();
    // let lang =i18n.language
    let [showPassword, setShowPassword] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [iState, updateState] = useState(initialState);
    const { email, password, errors, loading } = iState;
    const socketRef = useRef();
    // const SOCKET_SERVER_URL = 'https://bayin.app:4000';
    // useEffect(() => {

    //     socketRef.current = io(SOCKET_SERVER_URL, {
    //         transports: ['websocket'],
    //         reconnection: true,
    //         reconnectionAttempts: Infinity,
    //         reconnectionDelay: 1000,
    //         reconnectionDelayMax: 5000,
    //         randomizationFactor: 0.5,
    
    //       });
      
    //     socketRef.current.on('disconnect', (reason) => {
    //         console.log(`Socket disconnected: ${reason}`);
    //       });
      
    //       return () => {
    //         socketRef.current.disconnect();
    //       };
    // },[])
    const handleChange = (e) => {
        const { name, value } = e.target;
        updateState({
            ...iState,
            [name]: value,
        });
    };

    let handleValidation = () => {
        let error = {};
        let formIsValid = true;

        if (!email.trim()) {
            error.emailIdError = "*Email id can't be empty";
            error.formIsValid = false;
        } else {
            if (!/^.+?@.+?\..+$/.test(email)) {
                error.emailIdError = "*Email format is not valid";
                error.formIsValid = false;
            }
        }
        if (!password.trim()) {
            error.passwordError = "*Password can't be empty";
            formIsValid = false;
        }
        updateState({
            ...iState,
            errors: error,
        });
        return formIsValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let formIsValid = handleValidation();
        if (formIsValid) {
            updateState({ ...iState, loading: true })
            const data = { email: email.trim().toLowerCase(), password: password.trim() };
            dispatch(ownerLogin(data))
                .then((res) => {
                    if (res.status == 200) {
                        navigate("/dashboard");
                        toast.success(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        updateState({ ...iState, loading: false, email: "", password: "", errors: "" })
                    }
                    else if (res.status == 404) {
                        navigate("/");
                        toast.error(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        updateState({ ...iState, loading: false })
                    }
                    else {
                        toast.error(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                        })
                        updateState({ ...iState, loading: false })
                    }
                })
                .catch((err) => {
                    updateState({ ...iState, loading: false })
                    // console.log(err);
                });
        }

    };


    return (
        <div className="LoginArea" >
            <div className="LoginBox">
                <figure>
                    <img src={Logo} />
                </figure>
                {/* <span className="Language">
                    <aside>
                        <img src={Flag} />
                    </aside>
                    <select className="form-control">
                        <option>English</option>
                        <option>{t ("Arabic")}</option>
                    </select>
                </span> */}
                {/* <h3>{t ("Store_Owner_Login")}</h3> */}
                 <h3>Store Owner Login</h3>
                <h4>Welcome to the Bayin</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>E-mail</label>
                        <input type="email" className="form-control" placeholder="E-mail" name="email" value={email} onChange={handleChange} />
                        <span style={{ color: "red", fontSize: "12px" }}>{errors.emailIdError}</span>
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input type={showPassword ? "password" : "text"} className="form-control" placeholder="Password" name="password" value={password} onChange={handleChange} />
                        <span onClick={(e) => { setShowPassword(!showPassword); }}>
                            {showPassword ? (
                                <span className="Icon"><i className="fa fa-eye"></i></span>
                            ) : (
                                <span className="Icon cross"><i className="fa fa-eye"></i></span>
                            )}
                        </span>
                        {/* <span className="Icon"><i className="fa fa-eye"></i></span> */}
                        <span style={{ color: "red", fontSize: "12px" }}>{errors.passwordError}</span>
                    </div>
                    <button type="submit" disabled={loading}>Login</button>
                    {/* <Link to="/dashboard" className="Button">Login</Link> */}
                </form>
                <h6><Link to="/forgot" >Forgot Password ?</Link></h6>
                <p>Don't have an account? <Link to="/signup">Sign Up</Link></p>
            </div>
        </div>
    );
}
export default Login

